import { useSearchParams } from "react-router-dom";

import { useGetCurrentTeamMember, useGetPatients } from "~/providers/hooks";
import { defaultConsultationParams } from "~/providers/utils";
import Pagination from "../Pagination";
import { RequestsLayout } from "../RequestsLayout";
import { ConsultationRequestFilters } from "./ConsultationRequestsFilter";
import { ConsultationRequestsTable } from "./ConsultationRequestsTable";

export const ConsultationRequests = () => {
  const [params] = useSearchParams(defaultConsultationParams);

  const {
    data: consultationsRequests,
    isLoading,
    isFetched,
    isFetching,
  } = useGetPatients(params);

  const { data: teamMember } = useGetCurrentTeamMember();

  const organizationHasMultipleProviders = Boolean(
    (teamMember?.organization_team_members[0].organization.seats_count ?? 0) >
    1,
  );

  const {
    data: consultations,
    page,
    total_pages,
    total_items,
    filtered_count,
  } = { ...consultationsRequests };

  const hasConsultations = !!consultations?.length;

  const emptyDataForSearchCriteria =
    !isLoading && isFetched && !consultations?.length;

  const showPagination =
    !!total_pages && total_pages > 1 && filtered_count && page;

  return (
    <RequestsLayout>
      <ConsultationRequestFilters
        isLoading={isLoading}
        hasNoConsultations={!hasConsultations}
        filteredPatientsCount={filtered_count}
        totalPatients={total_items}
        isMultiProvider={organizationHasMultipleProviders}
      />
      <div className="flex size-full flex-col items-end justify-between gap-3">
        {!isLoading && (
          <ConsultationRequestsTable
            consultations={consultations}
            hasConsultations={hasConsultations}
            emptyDataForSearchCriteria={emptyDataForSearchCriteria}
            isFetching={isFetching}
          />
        )}
        {showPagination && (
          <Pagination
            totalItems={filtered_count}
            currentPage={page}
            totalPages={total_pages}
          />
        )}
      </div>
    </RequestsLayout>
  );
};
